module.exports = __webpack_public_path__ + "static/img/img1.05d261d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/img1.jpg
// module id = W9RC
// module chunks = 1